import { ValueOf } from '../../types/util.types'
import type { ITab } from '../tab/tab.type'

export const DEFAULT_PERIOD_LIST:ITab<string>[] = [
  { value: '7_day', label: '7D' },
  { value: '1_month', label: '1M' },
  { value: '6_month', label: '6M' },
  { value: '1_year', label: '1Y' },
  { value: '1_ytd', label: 'YTD' },
  { value: '1_all', label: 'ALL' },
  { value: 'selector', leftIcon: 'calendar' },
]

export const VIEW_PERIOD = {
  '1_DAY': '1_day',
  '7_DAY': '7_day',
  '1_MONTH': '1_month',
  '6_MONTH': '6_month',
  '1_YEAR': '1_year',
  '1_YTD': '1_ytd',
  '1_ALL': '1_all',
  SELECTOR: 'selector',
  NONE: '',
}

export const DATE_FORMAT = {
  DEFAULT_FORMAT: 'yyyy-MM-dd',
  FULL_FORMAT: 'yyyy-MM-dd HH:mm:ss',
  DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm',
  YEAR_FORMAT: 'yyyy',
  YEAR_MONTH_FORMAT: 'yyyy/MM',
  MONTH_DATE_FORMAT: 'MM/dd',
  TIME_FORMAT: 'HH:mm',
  ENG_FORMAT: 'MMM YYYY',
} as const
export type DATE_FORMAT = ValueOf<typeof DATE_FORMAT>